import type { CardProvider } from '../../queries/paymentQuery';
import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

export type RoleMappedToTsId = {
	id: string;
	label: string;
	mappedTSRoleId: string;
};

type RolesMappedToTsId = {
	teamAdmin: RoleMappedToTsId;
	manager: RoleMappedToTsId;
	teamMember: RoleMappedToTsId;
};

type RolesState = {
	role: {
		roles: Partial<RolesMappedToTsId>;
	};
};

type SetRolesArgs = {
	roles: RolesState['role']['roles'];
	cardprovider: CardProvider;
};

type RolesActions = {
	setRoles: ({ roles, cardprovider }: SetRolesArgs) => void;
};

export type RolesSlice = RolesState & RolesActions;

const rolesInitialState: RolesState = {
	role: {
		roles: {} as RolesMappedToTsId,
	},
};

export function rolesSlice(set: NamedSet<ZustandStore>): RolesSlice {
	return {
		...rolesInitialState,
		setRoles({ roles, cardprovider }: SetRolesArgs): void {
			set(
				(state: RolesState) => {
					if (cardprovider === 'HSBC' && roles.manager) {
						const { manager, ...rest } = roles;
						state.role.roles = rest;
					} else {
						state.role.roles = roles;
					}
					return state;
				},
				false,
				'[setRoles]',
			);
		},
	};
}
